import "./cart.scss";
import { html, nothing, PropertyValues } from "lit";
import ComponentCart from "../../../common-components/component-cart";
import { state } from "lit/decorators.js";
import { ProductDto } from "../../../model/dtos";
import { emptyCart } from "../redux/actions";
import "./button-helper-text";

enum ShopCartStates {
  "NONE",
  "QRCODE",
}

class ShopCart extends ComponentCart {
  static get tagName() {
    return "ncx-shop-cart";
  }

  @state()
  fullscreen: boolean = false;
  @state()
  status: ShopCartStates = ShopCartStates.NONE;

  constructor() {
    super();
    this.fullscreen = false;
  }

  protected updated(_changedProperties: PropertyValues): void {
    if (_changedProperties.has("fullscreen")) {
      this.classList.toggle("fullscreen", this.fullscreen);
    }
    if (_changedProperties.has("items")) {
      if (this.fullscreen === true && this.items.length === 0)
        this.fullscreen = false;
    }
  }

  async OnToggleCart() {
    this.fullscreen = !this.fullscreen;
  }

  render() {
    if (this.status !== ShopCartStates.QRCODE) return this.RenderCart();
    return this.RenderQrCode();
  }

  get itemsCounter() {
    return this.items.reduce((acc, item) => acc + item.quantity, 0);
  }

  RenderCart() {
    return html`
      <div class="ncx-shop-cart__row">
        <span> <i class="bi bi-bag"></i> ${this.itemsCounter} </span>
        <h5>${this.formatPrice().format(this.total)}</h5>
        <button
          @click=${this.OnToggleCart}
          class="btn btn-${this.fullscreen ? "secondary" : "primary"}"
          .disabled=${this.items.length === 0}
        >
          ${this.fullscreen !== true ? "MOSTRA" : "NASCONDI"} CARRELLO
        </button>
      </div>
      ${this.fullscreen === true
        ? html`
            ${this.RenderItems()}
            <button-helper-text
              text="Cliccando su CONFERMA verrà generato il codice QR da mostrare alla cassa"
            ></button-helper-text>
            <button
              @click=${this.OnContinue}
              class="btn btn-primary w-100 btn-lg"
            >
              CONFERMA
            </button>
          `
        : nothing}
    `;
  }

  async OnContinue() {
    this.status = ShopCartStates.QRCODE;
    await this.updateComplete;
    const items = this.items.map((item: ProductDto) => {
      let text = `${item.id}-${item.quantity}`;
      if (item.customizations) {
        item.customizations.forEach((customization, index) => {
          if (index === 0) text += `-`;
          else text += `,`;
          text += `${
            customization.customizationId
          }_${customization.customizations.map((c) => c.id).join(".")}`;
        });
      }
      return text;
    });
    const qrcodeText = items.join(";");
    console.log(qrcodeText);
    import("qrcode").then((QRCode) => {
      const canvas = this.querySelector("#qrcode");
      try {
        QRCode.toCanvas(
          canvas,
          qrcodeText,
          {
            width: canvas.parentElement.clientWidth,
          },
          function (error) {
            if (error) console.error(error);
            console.log("success!");
          }
        );
      } catch (error) {
        console.error(error);
      }
    });
  }

  RenderQrCode() {
    return html`
      <div class="ncx-shop-cart__qrcode-wrapper">
        <div class="fs-5 p-3">
          <span>Mostra il codice QR in cassa</span>
          <div class="or"><i>oppure</i></div>
          torna al
          <a
            href="javascript:void(0)"
            @click=${() => {
              this.status = ShopCartStates.NONE;
            }}
          >
            <i class="bi bi-bag"></i> carrello
          </a>
          <br />
          &nbsp;per rivedere l'ordine
        </div>
        <div class="qrcode-wrapper">
          <canvas id="qrcode"></canvas>
        </div>
        <button-helper-text
          text="Cliccando CHIUDI il carrello verrà svuotato"
        ></button-helper-text>
        <button
          @click=${() => {
            this.status = ShopCartStates.NONE;
            this.fullscreen = false;
            emptyCart();
          }}
          class="btn btn-primary w-100"
        >
          CHIUDI
        </button>
      </div>
    `;
  }
}
ShopCart.Register();
export default ShopCart;
